import { Address } from './Address'
import State from './State'

type LeadAddressInfo_ = {
  city: string
  state: string
  street: string
}

export type LeadAddressInfo = LeadAddressInfo_ & {
  __Type: 'leadAddressInfo'
}

export const leadAddressInfo = (lai_: LeadAddressInfo_): LeadAddressInfo => ({
  ...lai_,
  __Type: 'leadAddressInfo',
})

export const parseToLeadAddressInfo = (address: Address): LeadAddressInfo => ({
  __Type: 'leadAddressInfo',
  city: address.city,
  state: State.lookup(address.stateAbbreviation),
  street: address.street1,
})

export default { parseToLeadAddressInfo: parseToLeadAddressInfo }
